module.exports = __webpack_public_path__ + "img/logo.a244cfe1.png";